const s = (r) => r instanceof Error, a = (r) => {
  try {
    return [!1, r()];
  } catch (t) {
    return [s(t) ? t : new Error("tc: Thrown error not from ErrorConstructor"), void 0];
  }
}, l = async (r) => {
  try {
    return [!1, await r()];
  } catch (t) {
    return [s(t) ? t : new Error("tc: Thrown error not from ErrorConstructor"), void 0];
  }
}, o = (r, t, u = !0) => {
  if (!t)
    return (n, c) => o(r, n, c);
  const i = t.constructor.name === "AsyncFunction", e = (n) => {
    u && console.trace("tcf: ", n);
  };
  return i ? async (...n) => {
    try {
      return await t(...n);
    } catch (c) {
      return e(c), r;
    }
  } : (...n) => {
    try {
      return t(...n);
    } catch (c) {
      return e(c), r;
    }
  };
}, y = o(null), h = o(void 0), d = o(void 0);
o(0);
const w = (r) => o(r, r), E = o;
export {
  l as atc,
  E as safe,
  a as tc,
  y as tcNull,
  h as tcNullish,
  w as tcRetry,
  d as tcVoid,
  o as tcf
};
